module.exports = __webpack_public_path__ + "undo.aeea430e2ec71a5289929dbfa4893be0.svg";


//////////////////
// WEBPACK FOOTER
// ./web_modules/trustar/img/undo.svg
// module id = 1661
// module chunks = 39